// Common frequency options used across income forms
export const FREQUENCY_OPTIONS = [
  { id: 'weekly', label: 'Weekly' },
  { id: 'biweekly', label: 'Bi-Weekly' },
  { id: 'monthly', label: 'Monthly' },
  { id: 'semimonthly', label: 'Semi-Monthly' },
  { id: 'quarterly', label: 'Quarterly' },
  { id: 'yearly', label: 'Yearly' }
];

// State options for tax calculation
export const STATE_OPTIONS = [
  { id: 'AL', label: 'Alabama' },
  { id: 'AK', label: 'Alaska' },
  { id: 'AZ', label: 'Arizona' },
  { id: 'AR', label: 'Arkansas' },
  { id: 'CA', label: 'California' },
  { id: 'CO', label: 'Colorado' },
  { id: 'CT', label: 'Connecticut' },
  { id: 'DE', label: 'Delaware' },
  { id: 'FL', label: 'Florida' },
  { id: 'GA', label: 'Georgia' },
  { id: 'HI', label: 'Hawaii' },
  { id: 'ID', label: 'Idaho' },
  { id: 'IL', label: 'Illinois' },
  { id: 'IN', label: 'Indiana' },
  { id: 'IA', label: 'Iowa' },
  { id: 'KS', label: 'Kansas' },
  { id: 'KY', label: 'Kentucky' },
  { id: 'LA', label: 'Louisiana' },
  { id: 'ME', label: 'Maine' },
  { id: 'MD', label: 'Maryland' },
  { id: 'MA', label: 'Massachusetts' },
  { id: 'MI', label: 'Michigan' },
  { id: 'MN', label: 'Minnesota' },
  { id: 'MS', label: 'Mississippi' },
  { id: 'MO', label: 'Missouri' },
  { id: 'MT', label: 'Montana' },
  { id: 'NE', label: 'Nebraska' },
  { id: 'NV', label: 'Nevada' },
  { id: 'NH', label: 'New Hampshire' },
  { id: 'NJ', label: 'New Jersey' },
  { id: 'NM', label: 'New Mexico' },
  { id: 'NY', label: 'New York' },
  { id: 'NC', label: 'North Carolina' },
  { id: 'ND', label: 'North Dakota' },
  { id: 'OH', label: 'Ohio' },
  { id: 'OK', label: 'Oklahoma' },
  { id: 'OR', label: 'Oregon' },
  { id: 'PA', label: 'Pennsylvania' },
  { id: 'RI', label: 'Rhode Island' },
  { id: 'SC', label: 'South Carolina' },
  { id: 'SD', label: 'South Dakota' },
  { id: 'TN', label: 'Tennessee' },
  { id: 'TX', label: 'Texas' },
  { id: 'UT', label: 'Utah' },
  { id: 'VT', label: 'Vermont' },
  { id: 'VA', label: 'Virginia' },
  { id: 'WA', label: 'Washington' },
  { id: 'WV', label: 'West Virginia' },
  { id: 'WI', label: 'Wisconsin' },
  { id: 'WY', label: 'Wyoming' },
  { id: 'DC', label: 'District of Columbia' }
];

// Filing status options for tax forms
export const FILING_STATUS_OPTIONS = [
  { id: 'single', label: 'Single' },
  { id: 'married_separate', label: 'Married Filing Separately' },
  { id: 'married_joint', label: 'Married Filing Jointly' },
  { id: 'head_of_household', label: 'Head of Household' }
];

// Common validation messages
export const VALIDATION_MESSAGES = {
  required: 'This field is required',
  min: (min) => `Value must be at least ${min}`,
  max: (max) => `Value must be at most ${max}`,
  positive: 'Value must be positive',
  date: 'Please enter a valid date',
  email: 'Please enter a valid email address',
  phone: 'Please enter a valid phone number'
};

// Common tooltips
export const TOOLTIPS = {
  name: 'Enter a descriptive name for this income',
  employer: 'Enter the name of the company or client you\'re contracting with',
  startDate: 'Enter the start date of this income',
  endDate: 'Enter the end date of this contract (if it is not active)',
  isActive: 'Indicate whether this contract is currently active',
  grossPay: 'Enter the gross pay amount from your pay stub',
  netPay: 'Enter the net pay amount from your pay stub',
  frequency: 'Select how often you receive this income',
  state: 'Select the state where this income is earned',
  filingStatus: 'Select your tax filing status',
  dependents: 'Enter the number of qualifying dependents',
  deductions: 'Enter any pre-tax deductions (401k, health insurance, etc.)',
  selfEmploymentTax: 'Estimated self-employment tax (Social Security and Medicare taxes for self-employed individuals)',
  quarterlyTaxPayment: 'Estimated amount you should set aside for quarterly tax payments',
  takeHomePay: 'Estimated amount you\'ll take home after taxes',
  businessExpenses: 'Enter your estimated monthly business expenses',
  retirementContribution: 'Recommended amount to contribute to retirement accounts',
  autoWithholdTaxes: 'Enable to automatically calculate and set aside tax payments'
}; 